<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>Словари</strong>
                    <RestaurantTableOrderBadge />
                </CCardHeader>
                <CCardBody>
                    <RestaurantsTabLinks />
                    <CRow class="pl-3 pb-3" />

                    <CForm>

                        <CTabs
                            variant="pills"
                            :active-tab="0"
                        >

                            <CTab title="Пуши для клиентов" class="pt-1">
                                <Pushes
                                    :entity="entity"
                                    :type="'restaurant'"
                                    @save="save"
                                    @goBack="goBack"
                                />
                            </CTab>

                        </CTabs>
                    </CForm>
                </CCardBody>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import RestaurantsTabLinks from '@/components/RestaurantsTabLinks';
    import Pushes from '@/components/dictionaries/Pushes';

    export default {

        name: 'EntityDictionary',
        components: {
            RestaurantsTabLinks,
            Pushes,
        },

        data: () => ({
            entity: {}
        }),

        computed: {},

        async mounted() {
            const id = this.$route.params.id;
            this.entity = (await this.axios.get(`/restaurants/${id}`)).data;
        },

        methods: {
            async save(pushes) {
                try {
                    await this.axios.post(`/restaurants/${this.entity.id}/dictionary/pushes`, pushes);
                    this.$router
                        .push({ path: `/restaurants/${this.$route.params.id}` });
                } catch (error) {
                    this.$root.$emit('showError', 'Ошибка сохранения.');
                }
            },
            goBack() {
                this.$router
                    .push({ path: `/restaurants/${this.$route.params.id}` });
            },
        },
    };
</script>
